import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import videojs from 'video.js';
// import { HlsSourceHandler } from 'videojs-contrib-hls';
import Event from '../event/';
import Stat from '../vStat/';
import Util from '../utilPc/';
import TrySee from '../trySee/';
import PcTipsMask from '../pcTipsMask/';
// 引入videojs默认样式
import '!style-loader!css-loader!video.js/dist/video-js.min.css';
// 引入自定义样式
import '!style-loader!css-loader!./video_feng.css';
// 引入控制条上方APP推广广告
import '../plugins/appSpreadAd/';
// 引入自定义控制条按钮栏
import '../plugins/controlBarBtns/';
// 引入全屏模式下顶部标题控制栏
import '../plugins/fullScreenTitle/';
import getQrCode from '../base/getQrCode';
import hasSafeKeyword from '../base/hasSafeKeyword';

/**
 * 定义 Core 组件
 * 视频播放核心
 */
class Core extends PureComponent {
    static propTypes = {
        videoConfig: PropTypes.object.isRequired,
        videoJsOptions: PropTypes.object.isRequired,
        currentPlayIndex: PropTypes.number.isRequired,
        narrowWindowMode: PropTypes.bool.isRequired,
    };

    constructor(props) {
        super(props);

        /**
         * 统计模块
         */
        this.vStat = new Stat(this.props.videoConfig);

        /**
         * PC video方法库
         */
        this.pcUtil = new Util();

        /**
         * 是否为第一次播放
         */
        this.first_play = true;

        /**
         * 视频资源是否下载完成
         *
         * @member {Boolean}
         */
        this.bufferEnd = false;

        /**
         * 是否为第一次loadstart 2.0 loadstart
         *
         * @member {Boolean}
         */
        this.loadstartfirst = true;

        /**
         * 是否为第一次loadeddatafirst 2.0 loadeddata
         *
         * @member {Boolean}
         */
        this.loadeddatafirst = true;

        /**
         * seek 次数
         */
        this.seekTime = 0;

        /**
         * 上一次卡顿时间，为了监测卡顿
         *
         * @member {number}
         */
        this.lastCarTonTime = 0;

        /**
         * 监测卡顿标志
         *
         * @member {number}
         */
        this.carTonFlag = 1;

        /**
         * 卡顿持续时间
         *
         * @member {number}
         */
        this.stopContinue = 0;

        /**
         * 卡顿次数
         *
         * @member {number}
         */
        this.carTonTimes = 0;

        /**
         * 检查卡顿计时器
         */
        this.checkCarTonTimer = null;

        /**
         * 播放器初始化时发送统计
         */
        this.initSendVStat();

        this.state = {
            qrImg: '',
            trySeeShow: true,
            codeImgShow: false,
            closureTime:
                this.props.videoConfig.guideAppSetting && this.props.videoConfig.guideAppSetting.duration
                    ? this.props.videoConfig.guideAppSetting.duration
                    : 0,
            closureContentText:
                this.props.videoConfig.guideAppSetting && this.props.videoConfig.guideAppSetting.text
                    ? this.props.videoConfig.guideAppSetting.text
                    : '使用手机端观看完整版',
            closureEnable:
                this.props.videoConfig.guideAppSetting && this.props.videoConfig.guideAppSetting.enable
                    ? this.props.videoConfig.guideAppSetting.enable
                    : false,
            codeImgId: this.props.videoConfig.base62Id ? this.props.videoConfig.base62Id : '',
        };
    }

    initSendVStat = () => {
        /**
         * 发送vv统计
         */
        this.vStat.sendMedia('vv');
        /**
         * 采样标识统计
         */
        this.vStat.sendVplayer('100000');
    };

    /**
     * 初始化视频播放器配置
     */
    initPlayer = () => {
        const { keywords = '' } = this.props.videoInfo;
        if (this.player) {
            this.player.addClass('video_feng');
            // 需要自定义控制条样式，所以先移除默认控制条的组件，由自定义组件代替
            this.player.controlBar.removeChild('PlayToggle');
            this.player.controlBar.removeChild('NextVideoPanel');
            this.player.controlBar.removeChild('CurrentTimeDisplay');
            this.player.controlBar.removeChild('TimeDivider');
            this.player.controlBar.removeChild('DurationDisplay');
            this.player.controlBar.removeChild('VolumePanel');
            this.player.controlBar.removeChild('ChangeResPanel');
            this.player.controlBar.removeChild('FullscreenToggle');
            this.player.controlBar.removeChild('LiveDisplay');
            this.player.controlBar.removeChild('SeekToLive');
            this.player.controlBar.removeChild('CustomControlSpacer');
            if (!hasSafeKeyword(keywords)) {
                this.player.controlBar.addChild('AppSpreadAd');
            }
            // 引入自定义控制条按钮栏
            this.player.controlBar.addChild('FengControlBarVideoBtns');
            // 引入全屏模式下顶部标题控制栏
            this.player.addChild('FullScreenTitle');
        }
    };

    /**
     * 由于videojs生命周期的特殊性，这里需要包装一些videos的event供外部调用
     */
    activeTrigger = () => {
        if (!this.player) {
            setTimeout(() => {
                this.activeTrigger();
            }, 100);
        }

        this.player.on('loadstart', () => {
            // 发送统计
            // 开始加载
            if (this.loadstartfirst) {
                this.vStat.sendVplayer(208000);
                this.loadstartfirst = false;
            }

            let time = 0;

            // 加载资源10s超时报错
            this.tenSecondsOverTimer = setInterval(() => {
                time++;
                if (time >= 10) {
                    this.trigger('error', '9', this.player.currentTime());
                    clearInterval(this.tenSecondsOverTimer);
                }
            }, 1000);
        });

        this.player.on('loadedmetadata', () => {
            // 对于用户音量习惯进行一些调整
            const initVolume = Number(this.pcUtil.playerGetCookie('videoVolume')) || 0.5;

            this.player.volume(initVolume);

            this.trigger('init');
        });

        this.player.on('volumechange', () => {
            const currentVolume = this.player.volume();
            const muted = this.player.muted();

            this.trigger('volumechange', muted ? 0 : currentVolume);

            /**
             * 分为两种调节音量方式
             * 1、点击静音按钮
             * 2、拖拽音量控制条
             * 两种统计发送不相同，区别开
             */
            if (muted) {
                this.vStat.sendVplayer('405000');
            } else {
                this.pcUtil.playerSetCookie('videoVolume', currentVolume, {
                    domain: '.ifeng.com',
                    path: '/',
                    expires: 60 * 24 * 360,
                });

                const sendCode = Math.round(currentVolume * 100);

                /** 音量调节统计 例： 80发送080 */
                this.vStat.sendVplayer(`406${this.pcUtil.formatNum(sendCode)}`);
            }
        });

        this.player.on('loadeddata', () => {
            // 取消10s超时检查
            if (this.tenSecondsOverTimer) {
                clearInterval(this.tenSecondsOverTimer);
                this.tenSecondsOverTimer = null;
            }

            /**
             * 发送首字节统计
             */
            if (this.loadeddatafirst) {
                this.vStat.sendVplayer('302000');
                this.loadeddatafirst = false;
            }
        });

        this.player.on('canplay', () => {
            /**
             * 首画面呈现，发送统计
             */
            if (this.first_play) {
                // 发送首画面呈现统计
                this.vStat.sendVplayer('303000');
                // 发送cv统计
                this.vStat.sendMedia('cv');
                this.trigger('firstPlay');
                this.first_play = false;
            }

            this.trigger('canplay');
        });

        //  TODO:
        this.player.on('timeupdate', () => {
            const currentTime = this.player.currentTime();
            const bufferd = this.player.buffered();
            const bufferdTime = bufferd.length !== 0 ? bufferd.end(bufferd.length - 1) : 0;
            const duration = this.player.duration();

            if (this.state.closureEnable) {
                // this.setState({
                //     closureTime: closureDuration,
                //     closureContentText: closureText,
                // })

                let integerCurrentTime = Math.round(currentTime);

                // 开始播放10s 之后，试看提示标语 消失
                // 视频正常播放和 integerCurrentTime 有1s的延时差
                if (integerCurrentTime == 11) {
                    this.setState({
                        trySeeShow: false,
                    });
                }
                // 试看五分钟，结束后跳出弹窗
                if (integerCurrentTime > this.state.closureTime) {
                    // console.log('试看结束，弹出客户端二维码');
                    // console.log('this.videoNode', this.videoNode)
                    this.videoNode.pause();

                    const userPaused_lsh = this.player.paused();

                    if (userPaused_lsh) {
                        // 弹出二维码
                        this.setState({
                            codeImgShow: true,
                        });
                    }

                    this.player.on('pause', () => {
                        this.vStat.sendVplayer('402000');
                        this.trigger('pause');
                    });
                }
            }

            // 视频资源全部下载完成
            if (!this.bufferEnd && bufferdTime === duration && duration !== 0) {
                this.vStat.sendVplayer(307000);
                this.bufferEnd = true;
            }

            this.trigger('timeupdate', currentTime);
        });

        this.player.on('seeking', () => {
            // 视频seek统计，第一次403001
            this.vStat.sendVplayer(`403${this.pcUtil.formatNum(++this.seekTime)}`);
            this.trigger('seeking');
        });

        this.player.on('play', () => {
            this.vStat.sendVplayer('401000');
            this.trigger('play');
        });

        this.player.on('pause', () => {
            this.vStat.sendVplayer('402000');
            this.trigger('pause');
        });

        this.player.on('ended', () => {
            // 发送播放结束统计
            this.vStat.sendVplayer('305000');
            this.trigger('ended');
            if (this.player.isFullscreen()) {
                this.player.exitFullscreen();
            }
        });

        this.player.on('fullscreenchange', () => {
            const fullScreenStatus = this.player.isFullscreen();

            this.trigger(fullScreenStatus ? 'enterFullScreen' : 'exitFullScreen');

            // 发送全屏切换统计
            this.vStat.sendVplayer('404000');
        });

        this.player.on('error', () => {
            clearInterval(this.tenSecondsOverTimer);
            this.trigger('error', this.player.error().code, this.player.currentTime());

            if (window && window.BJ_REPORT) {
                const playerError = this.player.error() || {};
                const videoUrl = this.player.currentSource().src || '';
                window.BJ_REPORT.report(new Error(JSON.stringify({ playerError, videoUrl })), false, 25);
            }
        });
    };

    destory = () => {
        clearInterval(this.tenSecondsOverTimer);
        clearInterval(this.checkCarTonTimer);
        if (this.player) {
            this.player.dispose();
        }
    };

    checkVideoCarTon = () => {
        const userPaused = this.player.paused();
        // 用户暂停
        if (userPaused) return;
        // 未开始播放
        if (this.player.currentTime() === 0) return;

        if (this.lastCarTonTime === this.player.currentTime()) {
            if (this.carTonFlag) {
                this.vStat.sendVplayer(`304${this.pcUtil.formatNum(++this.carTonTimes)}`);
            }
            this.carTonFlag = 0;
            this.stopContinue++;
            if (this.stopContinue > 5) {
                // 卡顿时长超过5s，认为播放失败。显示后推荐
                this.stopContinue = 0;
                clearInterval(this.checkCarTonTimer);
                this.checkCarTonTimer = null;
                this.trigger('carTonError');
            } else {
                this.carTonFlag = 1;
                if (this.stopContinue !== 0) {
                    // 卡顿时长超过0s且低于5s
                    this.vStat.sendVplayer(
                        `309${this.pcUtil.formatNum(this.carTonTimes)}${this.pcUtil.formatNum(this.stopContinue)}`,
                    );
                    // 309xxxyy x：卡顿次数、y：卡顿时长
                    this.stopContinue = 0;
                }
            }
        }

        this.lastCarTonTime = this.player.currentTime();
    };

    reload = () => {
        if (this.player) {
            this.player.load();
        }
    };

    changeVolume = (volume) => {
        if (this.player) {
            this.player.volume(volume);
        }
    };

    changeSource = (source) => {
        this.player.src(source);
        this.player.play();
    };

    play = () => {
        if (this.player) {
            setTimeout(() => {
                this.player.play().catch((err) => {
                    console.error('self_video', err);
                    this.player.volume(0);
                    this.player.play();
                });
            }, 100);
        }
    };

    setCurrentTime = (sec) => {
        if (this.player) {
            this.player.currentTime(sec);
        }
    };

    async componentDidMount() {
        const {
            videoJsOptions,
            videoJsOptions: { sources },
            currentPlayIndex,
            narrowWindowMode,
        } = this.props;

        // videojs.getTech('html5').registerSourceHandler(HlsSourceHandler('html5'), 0);
        this.player = videojs(
            this.videoNode,
            {
                ...videoJsOptions,
                sources: sources[currentPlayIndex],
                width: narrowWindowMode ? 700 : videoJsOptions.width,
            },
            () => {
                // video hooks
                this.activeTrigger();
                // 检查卡顿，每秒检查一次
                this.checkCarTonTimer = setInterval(() => {
                    this.checkVideoCarTon();
                }, 1000);
            },
        );
        this.initPlayer();

        if (this.state.closureEnable) {
            // 截流功能开启，根据不同视频生成对应视频的专属二维码
            let path = 'https://ishare.ifeng.com/c/s/';
            let iSharePath = decodeURI(`${path}${this.state.codeImgId}`);

            const shareQrCode = await getQrCode(iSharePath);

            console.log('shareQrCode生成的二维码地址', shareQrCode);

            if (shareQrCode && shareQrCode.qrcode_url) {
                this.setState({
                    qrImg: shareQrCode.qrcode_url,
                });
            }
        }
    }

    UNSAFE_componentWillReceiveProps(props) {
        const {
            narrowWindowMode,
            videoJsOptions: { width },
        } = props;

        if (narrowWindowMode) {
            this.player.width(700);
        } else {
            this.player.width(width);
        }
    }

    componentWillUnmount() {
        this.destory();
    }

    render() {
        return (
            <div data-vjs-player>
                <video ref={(node) => (this.videoNode = node)} className="video-js" />
                {this.state.closureEnable === 1 && this.state.trySeeShow ? (
                    <TrySee qrImgContent={this.state.qrImg} closureTime={this.state.closureTime} />
                ) : null}
                {this.state.closureEnable === 1 && this.state.codeImgShow ? (
                    <PcTipsMask qrImgContent={this.state.qrImg} closureContentText={this.state.closureContentText} />
                ) : null}
            </div>
        );
    }
}

Event.mixTo(Core);
export default Core;
